import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function PaymentMethodCCAvenueConfigurationComponent({
  selectCCAVenues,
  handleCCAvenueFormChange,
  handleDeleteCCAvenueRow
}: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className="flex flex-col gap-6">
            {selectCCAVenues?.map((cc: any, idx: number) => (
              <div
                key={idx}
                className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 border rounded-md p-4 shadow-sm relative"
              >
                {selectCCAVenues?.length > 1 && (
                  <button
                    type="button"
                    className="absolute top-2 right-2 text-red-500 hover:text-red-700 rounded"
                    onClick={() => handleDeleteCCAvenueRow(idx)}
                    aria-label="Delete CCAvenue row"
                    title="Delete row"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#d0021b" fill="none">
                      <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="#d0021b" stroke-width="2" stroke-linecap="round"></path>
                      <path d="M9 11.7349H15" stroke="#d0021b" stroke-width="2" stroke-linecap="round"></path>
                      <path d="M10.5 15.6543H13.5" stroke="#d0021b" stroke-width="2" stroke-linecap="round"></path>
                      <path d="M3 5.5H21M16.0555 5.5L15.3729 4.09173C14.9194 3.15626 14.6926 2.68852 14.3015 2.39681C14.2148 2.3321 14.1229 2.27454 14.0268 2.2247C13.5937 2 13.0739 2 12.0343 2C10.9686 2 10.4358 2 9.99549 2.23412C9.89791 2.28601 9.80479 2.3459 9.7171 2.41317C9.32145 2.7167 9.10044 3.20155 8.65842 4.17126L8.05273 5.5" stroke="#d0021b" stroke-width="2" stroke-linecap="round"></path>
                    </svg>
                  </button>
                )}

                <InputContainer
                  label="Gateway Name"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event.target.value,
                      field: 'GatewayName',
                      idx,
                    })
                  }
                  type="text"
                  value={cc.GatewayName}
                />

                <InputContainer
                  label="Merchant Id"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event.target.value,
                      field: 'MerchantId',
                      idx,
                    })
                  }
                  type="text"
                  value={cc.MerchantId}
                />

                <InputContainer
                  label="Mapped Domain"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event.target.value,
                      field: 'MappedDomain',
                      idx,
                    })
                  }
                  type="text"
                  value={cc.MappedDomain}
                />

                <InputContainer
                  label="Working Key"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event.target.value,
                      field: 'WorkingKey',
                      idx,
                    })
                  }
                  type="text"
                  value={cc.WorkingKey}
                />

                <InputContainer
                  label="Access Code"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event.target.value,
                      field: 'AccessCode',
                      idx,
                    })
                  }
                  type="text"
                  value={cc.AccessCode}
                />

                <InputContainer
                  label="Active"
                  onValueChange={(event: any) =>
                    handleCCAvenueFormChange({
                      value: event,
                      field: 'IsActive',
                      idx,
                    })
                  }
                  type="checkbox"
                  value={cc.IsActive}
                />
              </div>
            ))}
          </div>
        }
        expandedPanel="CCAvenue Configuration Info"
        headerTitle="CCAvenue Information"
      />
    </>
  );
}
